import { useTranslation } from 'react-i18next';
import TitleText from '@/components/atoms/TitleText';
import InfoText from '@/components/atoms/InfoText';
import Button from '@/components/atoms/Button';
import { Link, useParams } from 'react-router-dom';

const AddProductHeader = () => {
  const { t } = useTranslation();
  const { sellerId } = useParams<{ sellerId: string }>();

  const buttonStyleClasses = "!w-[270px] !h-[46px] !gap-[8px] !rounded-[12px] !border-[1px] !pt-[12px] !pr-[24px] !pb-[12px] !pl-[24px] !bg-[var(--Button-Background-primary,#141414)] !border-[var(--Button-Background-primary,#141414)] hover:!bg-pink-500 hover:!border-pink-500 text-white font-semibold flex items-center justify-center";

  return (
    <div
      className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border-b border-gray-100 dark:border-neutral-800"
      data-testid="add-product-header"
    >
      <div data-testid="container" className="flex flex-col">
        <TitleText
          text={t('pageTitle')}
          className="!font-bold !text-[28px] text-neutral-900 dark:text-dark-text-primary"
        />
        <div data-testid="container" className="flex items-center gap-3">
          <Link to="/">
            <InfoText
              text={t('dashboard')}
              size="base"
              className="text-[#ACACAC] dark:text-[#ACACAC] hover:!text-gray-900 dark:hover:!text-gray-200 transition-colors cursor-pointer"
            />
          </Link>
          <InfoText
            text="/"
            size="base"
            className="text-neutral-400 dark:text-dark-text-secondary"
          />
          <Link
            to={sellerId ? `/sellers/${sellerId}/profile` : '/products'}
            state={sellerId ? { activeTab: 'products' } : undefined}
          >
            <InfoText
              text={t('breadcrumbList')}
              size="base"
              className="text-[#ACACAC] dark:text-[#ACACAC] hover:!text-gray-900 dark:hover:!text-gray-200 transition-colors cursor-pointer"
            />
          </Link>
          <InfoText
            text="/"
            size="base"
            className="text-[#ACACAC] dark:text-[#ACACAC]"
          />
          <InfoText
            text={t('breadcrumbCurrent')}
            size="base"
            className="!text-light-text-primary dark:text-dark-text-primary !font-normal"
          />
        </div>
      </div>

      <div data-testid="container" className="hidden sm:flex items-center gap-6">
        <Button
          type="submit"
          form="add-product-form"
          variant="primary"
          className={buttonStyleClasses}
          data-testid="save-product-button-desktop"
        >
          {t('saveProduct')}
        </Button>
      </div>

      <div className="sm:hidden fixed bottom-0 left-0 right-0 p-4 z-50 flex justify-center bg-white dark:bg-dark-surface border-t border-gray-100 dark:border-neutral-800" data-testid="add-product-mobile-footer">
        <Button
          type="submit"
          form="add-product-form"
          variant="primary"
          className={buttonStyleClasses}
          data-testid="save-product-button-mobile"
        >
          {t('saveProduct')}
        </Button>
      </div>
    </div>
  );
};

export default AddProductHeader;


